
<template>
    <div id="resourcelisting">
        <div class="resou-title">
            <span>服务管理 》人工智能</span>
        </div>
        <div style="background: #f2f2f2;display:flex;justify-content:space-between;">
            <div :style="{ display: 'inline-block', border: ' 1px solid #f2f2f2', width: rightwidth + 'px', }">
                <div class="demotitle">
                    <div style="padding-right: 10px;">
                        <div class="block"></div>
                        <span>AI算法功能</span>
                        <span style="float: right;">
                            <span @click="tabId = 0" class="access_tags">
                                <span class="xiaosho">AI算法列表</span>
                                <div style="margin-top: 0px;" v-show="tabId === 0" class="access_tagsyshi"></div>
                            </span>
                            <el-divider direction="vertical"></el-divider>
                            <span @click="tabId = 1" class="access_tags">
                                <span class="xiaosho">授权码管理</span>
                                <div style="margin-top: 0px;" v-show="tabId === 1" class="access_tagsyshi"></div>
                            </span>
                        </span>
                    </div>
                </div>
                <div class="demoheader">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item label="功能名称:">
                            <el-input style="width: 200px" v-model="formInline.ai_name" placeholder="请输入功能名称"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="mini" icon="el-icon-search" @click="AIinfolist">查询</el-button>
                            <el-button v-if="acctype == 3" type="primary" size="mini" @click="clearItem">重置</el-button>
                            <el-button v-if="acctype == 3" type="primary" size="mini"
                                @click="authshow = true">新增</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div v-if="tabId == 0 && leftlist.length != 0 && !authshow" :style="{
                    height: tabmaxheight - 100 + 'px', background: '#fff',
                }" class="overflow">
                    <div style="padding:10px ;border-bottom:1px solid #f2f2f2;" v-for="( item, index ) in  leftlist "
                        :key="index">
                        <el-row class="elasticbox">
                            <el-col :span="8">
                                <el-row>
                                    <el-col :span="8">
                                        <img style="width: 80px;height: 80px; margin-top: 10px;" :src="item.ai_pic"
                                            @error="handleImageError('', index)" alt="">
                                    </el-col>
                                    <el-col :span="16" class="container ">
                                        <p class="hideellipsis"
                                            style="font-size: 14px;font-weight: 500; margin-bottom: 8px;">AI功能：{{
                                                item.ai_name }}</p>
                                        <p class="hideellipsis" style="color: #7c8496;">服务商：{{ item.enterprise_name }}
                                        </p>
                                    </el-col>
                                </el-row>
                            </el-col>
                            <el-divider class="servicdivider" direction="vertical"></el-divider>
                            <el-col :span="16" style="padding: 10px 0px;">
                                <p :style="{ maxWidth: rightwidth - 536 + 'px' }" class="hideellipsis">{{
                                    item.ai_describe
                                }}
                                </p>
                                <p>版本：{{ item.ai_version }}&nbsp;更新时间：{{ item.utime_str }}
                                    <el-button style="float: right;margin-left: 10px;" type="text" v-if="acctype == 3"
                                        @click="infodel(item)" size="small">删除</el-button>
                                    <el-button style="float: right;margin-left: 10px;" type="text" @click="downimg(item)"
                                        size="small">下载</el-button>
                                    <el-button @click="manual(item)" style="float: right;" type="text"
                                        size="small">使用手册</el-button>
                                    <el-button @click="addauth(item)" style="float: right;" type="text"
                                        size="small">申请授权码</el-button>
                                </p>
                            </el-col>
                        </el-row>
                    </div>
                </div>
                <div v-if="tabId == 0 && authshow" :style="{
                    height: tabmaxheight - 100 + 'px', background: '#fff'
                }">
                    <div style="border-bottom: 1px solid #f2f2f2;padding-top: 10px;">
                        <span @click="AItabId = 0" class="access_tags">
                            <span class="xiaosho">添加AI产品</span>
                            <div v-show="AItabId === 0" class="access_tagsyshi"></div>
                        </span>
                        <span @click="AItabId = 1" class="access_tags">
                            <span class="xiaosho">使用手册</span>
                            <div v-show="AItabId === 1" class="access_tagsyshi"></div>
                        </span>
                        <el-button style="float: right;margin-right: 20px;" @click="authshow = false"
                            type="text">返回</el-button>
                    </div>
                    <div v-if="AItabId == 0" style="padding-top: 30px;">
                        <el-row>
                            <el-col :span="6" style="padding: 0px 20px;">
                                <el-upload style="margin-top: 18px;" class="avatar-uploader" id="createlogo" action="#"
                                    :show-file-list="false" :http-request="sculptureUpload" :auto-upload="false"
                                    :on-change="sculptureSuccess" list-type="picture">
                                    <img v-if="form.ai_pic" :src="form.ai_pic" />
                                    <div v-else class="creascuyyzz">
                                        <i class="el-icon-plus"></i>
                                    </div>
                                </el-upload>
                            </el-col>
                            <el-col :span="18">
                                <el-form ref="form" :rules="rules" :model="form" label-width="80px" class="aiinfoform"
                                    style="padding-right: 20px;">
                                    <el-row>
                                        <el-col :span="12">
                                            <el-form-item prop="ai_name" label="AI功能:">
                                                <el-input v-model="form.ai_name"
                                                    placeholder="请输入AI功能，如:体温检测/人脸识别.."></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item prop="ai_version" label="版本信息:">
                                                <el-input v-model="form.ai_version" placeholder="请输入版本信息"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="12">
                                            <el-form-item prop="ai_enterprise" label="所属企业:">
                                                <el-select style="width: 100%" v-model="form.ai_enterprise"
                                                    placeholder="请选择企业">
                                                    <el-option-group v-for="(group, index) in options" :key="index"
                                                        :label="group.label">
                                                        <el-option v-for="(item, index) in group.options" :key="index"
                                                            :label="item.enterprise_name" :value="item.enterprise_id">
                                                        </el-option>
                                                    </el-option-group>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item prop="file">
                                                <input type="file" ref="fileInput" style="display: none"
                                                    @change="handleFileChange">
                                                <div style="display: flex; align-items: center">
                                                    <el-input :disabled="true" type="text" v-model="form.ai_url"
                                                        style="flex: 1;"></el-input>
                                                    <el-button type="primary" @click="uploadFile">上传文件</el-button>
                                                </div>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-form-item prop="ai_describe" label="描述:">
                                        <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.ai_describe">
                                        </el-input>
                                    </el-form-item>
                                </el-form>
                                <el-button @click="add" style="margin-left: 30px;margin-top: 20px;"
                                    type="primary">确认</el-button>
                            </el-col>
                        </el-row>
                    </div>
                    <div v-if="AItabId == 1">
                        <v-quilleditor class="aiquill" :style="{
                            height: tabmaxheight - 140 + 'px',
                        }" v-model="form.ai_manual" :options="editorOption" @blur="onEditorBlur()"
                            @focus="onEditorFocus()" @ready="onEditorReady()" @change="onEditorChange()" />
                    </div>
                </div>
                <el-empty v-if="tabId == 0 && leftlist.length == 0 && !authshow" description="暂无数据" :style="{
                    height: tabmaxheight - 100 + 'px', background: '#fff'
                }"></el-empty>
                <div v-if="tabId == 1">
                    <el-table border ref="multipleTable" :data="tableData" style="width: 100%" :stripe="true"
                        :header-cell-style="{ background: '#f8f8f9', color: '#606266' }" v-loading="pictLoading"
                        :highlight-current-row="true" element-loading-background="#fff" element-loading-text="数据正在加载中"
                        element-loading-spinner="el-icon-loading" :height="tabmaxheight - 86"
                        @selection-change="handleSelectionChange" @wheel="handleScroll">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="ai_name" label="AI功能" :show-overflow-tooltip="true"></el-table-column>
                        <el-table-column prop="enterprise" label="Key" :show-overflow-tooltip="true"></el-table-column>
                        <el-table-column prop="ai_secret" label="Secret">
                        </el-table-column>
                        <el-table-column width="200" prop="enterprise_name" label="企业名称"
                            :show-overflow-tooltip="true"></el-table-column>
                        <el-table-column width="140" fixed="right" label="操作">
                            <template slot-scope="scope">
                                <div style="white-space: nowrap;">
                                    <el-button v-if="acctype == 3" type="text" @click="Secretset(scope.row)"
                                        size="small">设置Secret</el-button>
                                    <el-button type="text" @click="authdel(scope.row)" size="small">删除</el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div :style="{ display: 'inline-block', background: '#fff', border: ' 1px solid #f2f2f2', width: leftwidth, }"
                v-show="actab == true">
                <div
                    style="padding: 5px;height: 39px;line-height: 30px;white-space: nowrap;border-bottom: 1px solid #EBEEF5;text-align: center;">
                    <i v-show="foldshow == false" @click="foldshowclick" class="el-icon-s-fold xiaosho"
                        style="font-size: 20px;margin-top: 5px;float: left;"></i>
                    <i v-show="foldshow == true" @click="foldshowclick" class="el-icon-s-unfold xiaosho"
                        style="font-size: 20px;margin-top: 5px;float: left;"></i>
                    <div style="display: inline-block;vertical-align: top;" v-if="foldshow == true">平台AI服务</div>
                </div>
                <ul class="userzufujilist" :style="{ height: tabmaxheight - 50 + 'px', }" v-show="foldshow == true">
                    <li class="xiaosho" @mouseover="showDeleteIcon(index)" @mouseleave="hideDeleteIcon(index)"
                        :class="{ profilelist: profilelistStatus[index] }"
                        style="border-bottom: 1px solid #EBEEF5; height: 60px;line-height: 60px;text-indent:1.3em;"
                        v-for="( item, index ) in  rightlist " :key="index">
                        <img v-if="item.ai_pic" width="40" height="40" :src="'/api/common/files' + item.ai_pic" alt=""> {{
                            item.ai_name }}
                        <i v-show="profilelistStatus[index] && acctype == 3" @click="servicedel(item)"
                            class="el-icon-circle-close xiaosho"
                            style="font-size: 20px;float: right;line-height: inherit;margin-right: 10px;"></i>
                    </li>
                </ul>
                <div v-show="foldshow == true && acctype == 3" style="height:30px;width:100%;text-align: center;">
                    <i class="el-icon-plus xiaosho" @click="serviceadd"
                        style="font-size: 13px;font-weight: 400;margin-top: 5px; text-align: left; line-height: 30px;">
                        添加AI服务</i>
                </div>
                <div v-show="foldshow == false" :style="{ height: tabmaxheight + 'px', width: '3%' }">
                </div>
            </div>
        </div>
        <aiserviceadd ref="aiserviceadd" @list="AIservelist" />
        <el-dialog v-dialogDrag title="裁切图片" :visible.sync="cropperModel.val" width='65%' top="200px"
            :modal-append-to-body="false" v-if="cropperModel.val">
            <v-vuecropper :cropperModel="cropperModel" :imgFile="file" v-on:upload="sculptureUpload" :imgW="450"
                :imgH="174"></v-vuecropper>
        </el-dialog>
        <el-dialog v-dialogDrag title="使用手册" :visible.sync="AImanualModel.val" width='65%' top="200px"
            :modal-append-to-body="false" v-if="AImanualModel.val">
            <div :style="{
                height: tabmaxheight - 140 + 'px',
            }" class="overflow" v-if="manualhtml" v-html="manualhtml"></div>
            <el-empty v-else description="暂无数据" :style="{
                height: '200px',
            }"></el-empty>
        </el-dialog>
        <el-dialog v-dialogDrag title="设置Secret" :visible.sync="AISecretModel.val" width='35%' top="200px"
            :modal-append-to-body="false" v-if="AISecretModel.val">
            <div style="padding:30px;">
                <span>Secret:</span>
                <span>
                    <el-input v-model="Secret" placeholder="请输入Secret" style="width: 360px;"></el-input>
                </span>
            </div>
            <div class="toos_layer_footer">
                <el-button type="primary" @click="set" style="float: left;margin-left: 20px;">自动生成Secret</el-button>
                <el-button type="primary" @click="confirm">确定</el-button>
                <el-button type="primary" @click="AISecretModel.val = false, Secret = ''">取消</el-button>
            </div>
        </el-dialog>
        <div class="cr_footer">
            <div class="footer_left">
                <i class="el-icon-place"></i>
                <div id="box">
                    <ul id="con1" :class="{ anim: animate == true }">
                        <li v-for=' item  in  items ' :key="item.name">{{ item.name }}</li>
                    </ul>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import vuecropper from '../commonComponents/vueCropper'
import aiserviceadd from './aiserviceadd.vue'
import "../common/common.css"
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
export default {
    components: {
        "v-quilleditor": quillEditor,
        "v-vuecropper": vuecropper,
        aiserviceadd
    },
    data() {
        return {
            editorOption: {
                placeholder: "请输入需要编写的内容...",
                modules: {
                    toolbar: [
                        ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
                        ["blockquote", "code-block"], // 引用  代码块
                        [{ header: 1 }, { header: 2 }], // 1、2 级标题
                        [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
                        [{ script: "sub" }, { script: "super" }], // 上标/下标
                        [{ indent: "-1" }, { indent: "+1" }], // 缩进
                        [{ direction: "rtl" }], // 文本方向
                        [
                            {
                                size: [
                                    "12",
                                    "14",
                                    "16",
                                    "18",
                                    "20",
                                    "22",
                                    "24",
                                    "28",
                                    "32",
                                    "36",
                                ],
                            },
                        ], // 字体大小
                        [{ header: [1, 2, 3, 4, 5, 6] }], // 标题
                        [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
                        // [{ font: ['songti'] }], // 字体种类
                        [{ align: [] }], // 对齐方式
                        ["clean"], // 清除文本格式
                        ["image", "video"], // 链接、图片、视频
                    ],
                },
            },
            items: [{ name: "收到人脸设备（位置：北京大学东门入口点，设备编号：AICR-200120）注册数剧等等" },
            { name: "收到人脸设备（位置：北京大学东门入口点，设备编号：AICR-200122）注册数剧等等" },
            { name: "收到人脸设备（位置：北京大学东门入口点，设备编号：AICR-200123）注册数剧等等" }],
            tabmaxheight: window.innerHeight - 200,
            formInline: {
                ai_name: ''
            },
            tabId: 0,
            AItabId: 0,
            timie: null,
            animate: false,
            actab: true,
            foldshow: true,
            pictLoading: false,
            authshow: false,
            leftwidth: '300px',
            acctype: localStorage.getItem('acctype'),
            options: JSON.parse(localStorage.getItem('entinfolist')),
            rightwidth: window.innerWidth - 390,
            rightlist: [],
            leftlist: [],
            multipleSelection: [],
            tableData: [],
            form: {
                ai_name: '',
                ai_describe: '',
                ai_pic: '',
                ai_manual: '',
                ai_enterprise: '',
                ai_version: '',
                ai_url: '',
            },
            rules: {
                ai_name: [
                    { required: true, message: '请输入AI功能', trigger: 'blur' },
                ],
                ai_version: [
                    { required: true, message: '请输入版本信息', trigger: 'blur' },
                ],
                ai_describe: [
                    { required: true, message: '请输入描述', trigger: 'blur' },
                ],
            },
            file: '',
            ai_pic: '',
            cropperModel: { val: false },
            AImanualModel: { val: false },
            AISecretModel: { val: false },
            manualhtml: '',
            profilelistStatus: [],
            Secret: '',
            secretrow: {},
        };
    },
    mounted() {
        this.AIservelist()
        this.AIinfolist()
        this.AIauthlist()
        this.timie = setInterval(this.scroll, 2000)
        window.addEventListener('resize', this.calculateTableHeight)
    },
    watch: {
        tabId(val) {
            if (val == 0) {
                this.AIservelist()
                this.AIinfolist()
            } else {
                this.AIauthlist()
            }
        },
        authshow(val) {
            if (val) {
                Object.keys(this.form).forEach((key) => {
                    this.form[key] = "";
                });
            }
        },
    },
    methods: {
        set() {
            this.$tools
                .asyncPost(this, this.$baseUrl.aiauthgetsecret, {
                    data: {

                    }
                })
                .then((res) => {
                    if (res.data.code == 0) {
                        this.Secret = res.data.data
                    } else {
                        this.$message({ type: "error", message: res.data.msg });
                    }
                })
                .catch((err) => {
                });
        },
        confirm() {
            this.$set(this.secretrow, 'ai_secret', this.Secret)
            this.$tools
                .asyncPost(this, this.$baseUrl.aiauthedit, {
                    data: {
                        ...this.secretrow
                    }
                })
                .then((res) => {
                    if (res.data.code == 0) {
                        this.AISecretModel.val = false
                        this.$message({ type: "success", message: res.data.msg });
                        this.AIauthlist()
                    } else {
                        this.$message({ type: "error", message: res.data.msg });
                    }
                })
                .catch((err) => {
                });
        },
        Secretset(row) {
            this.AISecretModel.val = true
            this.secretrow = row
        },
        handleImageError(e, index) {
            this.leftlist[index].ai_pic = require(`@/assets/cr_ai_default.png`);
        },
        showDeleteIcon(index) {
            this.$set(this.profilelistStatus, index, true);
        },
        hideDeleteIcon(index) {
            this.$set(this.profilelistStatus, index, false);
        },
        serviceadd() {
            this.$refs.aiserviceadd.init()
        },
        manual(row) {
            this.AImanualModel.val = true
            this.manualhtml = row.ai_manual
        },
        downimg(row) {
            const link = document.createElement('a');
            link.href = this.$baseUrl.files + '/' + row.ai_url
            link.download = row.ai_name
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        servicedel(row) {
            this.$MessageBox.confirm('此操作将删除该AI服务', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(() => {
                this.$tools
                    .asyncPost(this, this.$baseUrl.aiservicedel, {
                        data: {
                            ids: Array(row.id)
                        }
                    })
                    .then((res) => {
                        if (res.data.code == 0) {
                            this.AIservelist()
                            this.$message({ type: "success", message: res.data.msg });
                        } else {
                            this.$message({ type: "error", message: res.data.msg });
                        }
                    })
                    .catch((err) => {
                    });
            })
        },
        infodel(row) {
            this.$MessageBox.confirm('此操作将删除该AI算法功能', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(() => {
                this.$tools
                    .asyncPost(this, this.$baseUrl.aiinfodel, {
                        data: {
                            ids: Array(row.ai_id)
                        }
                    })
                    .then((res) => {
                        if (res.data.code == 0) {
                            this.AIinfolist()
                            if (row.ai_pic) {
                                this.imgdel(Array(row.ai_pic))
                            }
                            this.$message({ type: "success", message: res.data.msg });
                        } else {
                            this.$message({ type: "error", message: res.data.msg });
                        }
                    })
                    .catch((err) => {
                    });
            })
        },
        authdel(row) {
            this.$MessageBox.confirm('此操作将删除该AI授权码', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(() => {
                this.$tools
                    .asyncPost(this, this.$baseUrl.aiauthdel, {
                        data: {
                            ids: Array(row.id)
                        }
                    })
                    .then((res) => {
                        if (res.data.code == 0) {
                            this.AIauthlist()
                            if (row.ai_pic) {
                                this.imgdel(Array(row.ai_pic))
                            }
                            this.$message({ type: "success", message: res.data.msg });
                        } else {
                            this.$message({ type: "error", message: res.data.msg });
                        }
                    })
                    .catch((err) => {
                    });
            })

        },
        add() {
            this.$set(this.form, 'ai_pic', this.ai_pic)
            this.$tools
                .asyncPost(this, this.$baseUrl.aiinfoadd, {
                    data: {
                        ...this.form
                    }
                })
                .then((res) => {
                    if (res.data.code == 0) {
                        this.AIinfolist()
                        this.authshow = false
                        this.$message({ type: "success", message: res.data.msg });
                    } else {
                        if (this.ai_pic) {
                            this.imgdel(Array(this.ai_pic))
                        }
                        this.$message({ type: "error", message: res.data.msg });
                    }
                })
                .catch((err) => {
                });
        },
        uploadFile() {
            this.$refs.fileInput.click();
        },
        getContent(e) {
            this.form.ai_manual = e;
        },
        async handleFileChange() {
            const formData = new FormData();
            formData.append('file', this.$refs.fileInput.files[0]);
            this.form.ai_url = await this.upload(formData, 1)
        },
        clearItem() {
            let target = event.target;
            if (target.nodeName == "SPAN") {
                target = event.target.parentNode;
            }
            target.blur()
            Object.keys(this.formInline).forEach((key) => {
                this.formInline[key] = "";
            });
        },
        sculptureSuccess(res, file) {
            this.cropperModel.val = true
            this.file = file;
        },
        async sculptureUpload(file) {
            this.form.ai_pic = file
            var formdata = new FormData()
            var files = this.convertBase64ToFile(file, 'AI图片');
            formdata.append('file', files, this.file[this.file.length - 1].name);
            formdata.append('rename', '1');
            this.ai_pic = await this.upload(formdata, 2)
        },
        imgdel(paths) {
            this.$tools
                .asyncPost(this, this.$baseUrl.filesdel, {
                    data: {
                        bucket: localStorage.getItem('enterprise_id'),
                        paths: paths,
                    }
                })
                .then((res) => {
                    if (res.data.code == 0) {
                    } else {
                        this.$message({ type: "error", message: res.data.msg });
                    }
                })
                .catch((err) => {
                });
        },
        async upload(formdata, type) {
            var url
            if (type == 1) {
                url = this.$baseUrl.filesupload + '/public/ai/'
            } else {
                url = this.$baseUrl.filesupload + '/public/AIserve/'
            };
            try {
                //' + localStorage.getItem('enterprise_id') + '
                const res = await this.$axios.post(url, formdata, {
                    headers: {
                        'token': localStorage.getItem("token"),
                        'content-type': 'multipart/form-data'
                    }
                });
                if (res.data.code == 0) {
                    return res.data.data[res.data.data.length - 1].upload_path;
                }
            } catch (err) {

            }
        },
        convertBase64ToFile(base64String, fileName) {
            const byteCharacters = atob(base64String.substring(base64String.indexOf(',') + 1));
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'image/jpg' });
            const file = new File([blob], fileName, { type: blob.type });
            return file;
        },
        addauth(item) {
            this.$tools
                .asyncPost(
                    this,
                    this.$baseUrl.aiauthadd, {
                    data: {
                        ai_id: item.ai_id,
                        enterprise: item.ai_enterprise,
                        user_id: JSON.parse(localStorage.getItem('useritem')).id

                        // enterprise_id: localStorage.getItem('enterprise_id')
                    }
                })
                .then((res) => {
                    if (res.data.code == 0) {
                        this.$message({ type: "success", message: res.data.msg });
                    } else if (res.data.code == 2003) {
                        this.$message({ type: "error", message: '已申请授权码' });
                    } else {
                        this.$message({ type: "error", message: res.data.msg });
                    }
                }).catch((err) => { });
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        handleScroll(event) {
            const tableEl = event.target;
            const scrollAmount = event.deltaY * 0.5; // 调整滚动速度
            tableEl.scrollLeft += scrollAmount;
        },
        AIauthlist() {
            this.pictLoading = true
            this.$tools
                .asyncPost(
                    this,
                    this.$baseUrl.aiauthlist, {
                    data: {
                        ...this.formInline,
                        user_id: JSON.parse(localStorage.getItem('useritem')).id
                    }
                })
                .then((res) => {
                    if (res.data.code == 0) {
                        this.tableData = res.data.data.data
                    } else {
                        this.$message({ type: "error", message: res.data.msg });
                    }
                    this.pictLoading = false
                }).catch((err) => { this.pictLoading = false });
        },
        AIinfolist() {
            this.$tools
                .asyncPost(
                    this,
                    this.$baseUrl.aiinfolist, {
                    data: {
                        ...this.formInline,
                        user_id: JSON.parse(localStorage.getItem('useritem')).id
                    }
                })
                .then((res) => {
                    if (res.data.code == 0) {
                        this.leftlist = res.data.data.data
                        this.leftlist.forEach((item) => { return item.ai_pic = '/api/common/files' + item.ai_pic })
                    } else {
                        this.$message({ type: "error", message: res.data.msg });
                    }
                }).catch((err) => { });
        },
        AIservelist() {
            this.$tools
                .asyncPost(
                    this,
                    this.$baseUrl.aiservicelist, {
                    data: {
                        // enterprise_id: localStorage.getItem('enterprise_id'),
                        // user_id: JSON.parse(localStorage.getItem('useritem')).id
                    }
                })
                .then((res) => {
                    if (res.data.code == 0) {
                        this.rightlist = res.data.data.data
                    } else {
                        this.$message({ type: "error", message: res.data.msg });
                    }
                }).catch((err) => { });
        },
        foldshowclick() {
            this.foldshow = !this.foldshow;
            switch (this.foldshow) {
                case true:
                    this.rightwidth = this.rightwidth - 265;
                    this.leftwidth = "300px";
                    break;
                case false:
                    this.rightwidth = this.rightwidth + 265;
                    this.leftwidth = "35px";
                    break;
            }
        },
        calculateTableHeight() {
            // 根据视图高度计算表格高度的逻辑
            this.tabmaxheight = window.innerHeight - 205; // 示例：表格高度为窗口高度减去
            this.rightwidth = window.innerWidth - 390;
        },
        scroll() {
            let con = document.getElementById('con1')
            con.style.marginTop = '-34px';
            this.animate = !this.animate;
            var that = this; // 在异步函数中会出现this的偏移问题，此处一定要先保存好this的指向
            setTimeout(function () {
                that.items.push(that.items[0]);
                that.items.shift();
                con.style.marginTop = '0px';
                that.animate = !that.animate;  // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
                this.timie = null
            }, 1000)
        },
        // 失去焦点事件
        onEditorBlur() { },
        // 获得焦点事件
        onEditorFocus() { },
        // 准备编辑器
        onEditorReady() { },
        // 内容改变事件
        onEditorChange() { },
        // 获取已有的文本内容

    },
    beforeDestroy() {
        clearInterval(this.timie);
        this.timie = null;
        window.removeEventListener('resize', this.calculateTableHeight);
    },
};
</script>
<style lang="scss">
.aiquill {
    .ql-container {
        height: calc(100% - 42px);
    }
}
</style>
<style scoped lang="scss">
.container {
    padding: 20px 0px;
}

.aiinfoform {
    .el-form-item {
        margin: 18px 0px 0px 0px;
    }
}

.profilelist:hover {
    background: #AEE1F1;
}

.demotitle {
    padding-left: 15px;
    border-bottom: 1px solid #f2f2f2;
    height: 40px;
    line-height: 40px;
    background: #fff;
}

.demoheader {
    background: #fff;
    padding: 10px 0px 10px 30px;
    display: flex;
    justify-ai_manual: left;
    border-bottom: 1px solid #f2f2f2;
    margin-bottom: 10px;
}

.servicdivider {
    height: 6em;
}

.block {
    width: 10px;
    height: 10px;
    background: #0079FE;
    display: inline-block;
    margin-right: 5px;
}

@import './resourcelisting.css';
</style>